import { useCallback, useState } from "react";

interface IAvatarWithFallbackProps {
  src?: string | null;
  alt: string;
  className?: string;
  name: string;
  size?: number;
}

export default function AvatarWithFallback({
  src,
  alt,
  className,
  name,
  size = 32,
}: IAvatarWithFallbackProps) {
  const [imageError, setImageError] = useState(false);
  
  const handleImageError = useCallback(() => {
    setImageError(true);
  }, []);

  // Name'in ilk harfini al ve büyük harfe çevir
  const firstLetter = name?.charAt(0)?.toUpperCase() || "?";

  return (
    <div
      className={`flex items-center justify-center bg-muted text-muted-foreground font-semibold rounded-full overflow-hidden ${className || ""}`}
      style={{
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
      }}
    >
      {imageError || !src ? (
        <div
          className="flex items-center justify-center w-full h-full"
          style={{
            fontSize: size * 0.4, // Harfin boyutu container'ın %40'ı kadar
          }}
        >
          {firstLetter}
        </div>
      ) : (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          onError={handleImageError}
          className="w-full h-full object-cover rounded-full"
        />
      )}
    </div>
  );
}

